var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRectangle6A33F9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 14,
    rx: 0,
    stroke: "#6A33F9",
    strokeWidth: 3,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#6A33F9"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 7,
    x2: 8,
    y2: 0,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 15,
    x2: 16,
    y2: 0,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 23,
    x2: 24,
    y2: 0,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 31,
    x2: 32,
    y2: 0,
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle6A33F9);
export default __webpack_public_path__ + "static/media/rectangle-6A33F9.3009cd195f125707edd107de9bb679a6.svg";
export { ForwardRef as ReactComponent };